import { Swiper, Navigation } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

window.addEventListener('load', () => {
  const prevBtn = '.landscape-photos__nav--prev';
  const nextBtn = '.landscape-photos__nav--next';
  const sliderName = '.landscape-photos__swiper-container';

  function hidePrevSlides() {
    this.slides.forEach((slide, index) => {
      if (index < this.activeIndex) {
        slide.classList.add('hidden');
      } else {
        slide.classList.remove('hidden');
      }
    });
  }

  // eslint-disable-next-line no-new
  new Swiper(sliderName, {
    modules: [Navigation, HideOffscreenSlides],
    speed: 700,
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    preloadImages: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    on: {
      slideChange() {
        hidePrevSlides.call(this);
      },
    },
  });
});
